export const LS_LOGIN_AFTER_CREATE = 'hc-login-after-create';
